<template>
    <v-dialog
        v-model="dialog"
        persistent
        max-width="390"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-row class="downloadRow">
        <v-btn
            class="searchButton"
            color="#ffdb58"
            v-bind="attrs"
            v-on="on"
        >
          Get your <br> proof of delivery
        </v-btn>
        </v-row>
      </template>
      <v-card>
        <v-card-title class="text-h6">
          Please provide the recipient <br> postal code
        </v-card-title>
        <v-card-text>
          Please enter the postal code of the recipient to receive the electronic proof of delivery.<br/>You have <b>{{3-counter}}</b> {{3-counter === 1 ? 'try' : 'tries'}} left.
        </v-card-text>
        <v-card-text>
            <v-text-field
                v-model="userInputPlz"
                color="#F57F17"
                counter="10"
                label="Postal Code"
                v-on:keyup.enter="counter < 3 ? downloadPod(caseId, userInputPlz) : null"
            ></v-text-field>
        </v-card-text>
        <v-card-text v-if="fetchState === 3">
          <p class="errorTextDialog">No document was found. <br/>Please try a different postal code.<br/>You have <b>{{3-counter}}</b> {{3-counter === 1 ? 'try' : 'tries'}} left.</p>
          <p class="errorTextDialog"></p>
        </v-card-text>
        <v-card-text v-else-if="fetchState === 2">
          <p class="successTextDialog">Document has been downloaded. <br/>Please take a look into your download folder.</p>
          <p class="successTextDialog"></p>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
              color="secondary"
              text
              @click="cancelDialog()"
          >
            {{ dialogCancelText }}
          </v-btn>
          <v-btn v-if="fetchState === 0 ||fetchState === 3"
              color="#F57F17"
              text
              :disabled="counter >= 3"
              @click="downloadPod(caseId, userInputPlz)"
          >
            Download
          </v-btn>
          <v-progress-circular v-else-if="fetchState === 1"
          indeterminate
          color="secondary">
          </v-progress-circular>
        </v-card-actions>
      </v-card>
    </v-dialog>
</template>

<script>

import axios from "axios";

export default {
  name: "podDialog",

  props: {
    caseId: null,
    token: null,
    deliveryDate: null
  },

  data() {
    return {
      dialog: false,
      userInputPlz: "",
      error: false,
      counter: 0,
      errorThreshold: 3,
      loading: false,
      fetchState: 0, //0 = none, 1 = loading, 2 = successful, 3 = no document found
      dialogCancelText: "Cancel"
    }
  },
  mounted(){
    this.fetchState = 0
  },

  methods: {

    cancelDialog() {
      this.userInputPlz = ""
      this.dialog = false
      this.fetchState = 0
    },

    /**
     * Downloads the pdf
     * @param caseid
     * @param zipCode
     * @returns {Promise<void>}
     */
    async downloadPod(caseid, zipCode) {
      this.loading = true
      this.fetchState = 1

      let pdfBase64 = null;
      //add bearer token to header
      let apiConfig = {
        headers: {
          Authorization: "Bearer " + this.token
        }
      }

      //get document
      await axios.get(process.env.VUE_APP_API_DOCUMENT + "?CaseId=" + caseid + "&ZipCode=" + zipCode, apiConfig)
          .then((response) => {
            pdfBase64 = response.data
            //download to pdf
            this.base64toPDF(pdfBase64, caseid, this.deliveryDate)
            //reset counter
            this.counter = 0
            //close window and set error to false
            this.fetchState = 2
            this.dialogCancelText = "Close"
          })
          .catch((error) => {
            error.response.status === 404 ? this.handleDocumentNotFound() : null
          })
    },
    /**
     * set error and add to counter when status was 404
     */
    handleDocumentNotFound(){
      this.counter += 1
      this.fetchState = 3
    },
    /**
     * Transform arraybuffer to pdf and downloads it directly
     * @param data
     * @param caseid
     * @param deliveryDate
     */
    base64toPDF(data, caseid, deliveryDate) {
      const bufferArray = this.base64ToArrayBuffer(data);
      const blobStore = new Blob([bufferArray], {type: "application/pdf"});
      if (window.navigator && window.navigator.msSaveOrOpenBlob) {
        window.navigator.msSaveOrOpenBlob(blobStore);
        return;
      }

      const pdf = window.URL.createObjectURL(blobStore);
      const link = document.createElement('a');

      document.body.appendChild(link);
      link.href = pdf;
      link.download = "pod_" + caseid + "_" + deliveryDate.replaceAll('-', '') + ".pdf";
      link.click();
      window.URL.revokeObjectURL(pdf);
      link.remove();
    },
    /**
     * Transforms string of base64 to an array for. Needed for pdf transformation
     * @param data
     * @returns {Uint8Array}
     */
    base64ToArrayBuffer(data) {
      const bString = window.atob(data);
      const bLength = bString.length;
      let bytes = new Uint8Array(bLength);
      for (var i = 0; i < bLength; i++) {
        var ascii = bString.charCodeAt(i);
        bytes[i] = ascii;
      }
      return bytes;
    }
  }
}
</script>


<style scoped>

</style>